/**
 * This component is a resolver. It is meant to be used by page templates using
 * data from a CMS.
 *
 * You can send the data you receive from the CMS to the props of this components
 * by spreading them (like <ContentWithImage {...cmsData} />)
 * and then make these props fit the final module.
 *
 * Note that propTypes are not needed in this component: the GraphQL schema
 * definition is sufficient for that matter.
 */
import React from "react"
import { graphql } from "gatsby"
import { Section, CmsImage } from "@bw/bits"
import { ContentWithImage as ContentWithImageModule } from "@bw/modules"
// parse is used to ensure that HTML sent by the CMS is converted to React components
import parse from "html-react-parser"

const ContentWithImage = ({
  suptitle,
  title,
  subtitle,
  button,
  buttonPosition,
  text,
  orientation,
  image,
  anchor,
}) => {
  return (
    <Section
      {...{
        suptitle,
        title,
        subtitle,
        button,
        buttonPosition: buttonPosition?.value,
        anchor,
      }}
    >
      <ContentWithImageModule
        text={text ? parse(text) : undefined}
        orientation={orientation?.value}
        image={<CmsImage src={image} alt={title} />}
      />
    </Section>
  )
}

/**
 * This generates a GraphQL Fragment that can be used in a page query:
 *
 * Example:
 * ... on ContentWithImageModule {
 *   ...ContentWithImageModuleFragment
 * }
 *
 * This is also what you will get in the props of your ContentWithImage
 * resolver component.
 */
export const query = graphql`
  fragment ContentWithImageModuleFragment on ContentWithImageModule {
    image {
      localImage {
        childImageSharp {
          gatsbyImageData(width: 800)
        }
      }
    }
    orientation {
      value
    }
    text
  }
`

export { ContentWithImage }
